import { Box } from "@mui/material";
import { useMatches } from "@tanstack/react-router";

import { SubNav } from "./SubNav";
import { TopNav } from "./TopNav";
import { useActiveNavGroup } from "./useActiveNavGroup";

import { HorizontalProgress } from "@/components/HorizontalProgress/HorizontalProgress";

const HEX_BAR_HEIGHT = 8;

export function Navbar() {
  const { activeGroup, activeSubLink } = useActiveNavGroup();
  const matches = useMatches();

  // The SKU Store subnav is landing-level navigation; hide it once a product
  // detail page is open (that context has its own top/side nav).
  const isSkuStoreDetail = matches.some((match) =>
    match.routeId?.includes("/sku-store/$siteId/$skuId"),
  );
  const showSubNav =
    !isSkuStoreDetail &&
    Boolean(activeGroup?.subLinks && activeGroup.subLinks.length > 0);

  return (
    <Box
      component="header"
      sx={{
        position: "relative",
        width: "100%",
        backgroundColor: "common.white",
        borderBottom: `1px solid`,
        borderColor: "tokens.outlines.defaultBordersLight",
      }}
    >
      <Box>
        <TopNav activeGroup={activeGroup} />
        {showSubNav && activeGroup && (
          <SubNav group={activeGroup} activeSubLink={activeSubLink} />
        )}
      </Box>
      <Box
        sx={{
          height: HEX_BAR_HEIGHT,
          backgroundImage: `url("https://cdn.queen.one/connect/ui/hex-bar.png")`,
          backgroundPosition: "center",
          backgroundSize: `1728px ${HEX_BAR_HEIGHT}px`,
          backgroundRepeat: "repeat-x",
        }}
      />
      <HorizontalProgress />
    </Box>
  );
}
